import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Projects API
export const projectsApi = {
  create: (data) => axios.post(`${API}/projects`, data),
  getAll: () => axios.get(`${API}/projects`),
  getById: (id) => axios.get(`${API}/projects/${id}`),
  submit: (id) => axios.post(`${API}/projects/${id}/submit`),
  uploadVideo: (id, videoType, file, onProgress) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/projects/${id}/videos?video_type=${videoType}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (progressEvent) => {
        if (onProgress) {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(percent);
        }
      }
    });
  },
  getVideoUrl: (projectId, videoId, token) => 
    `${API}/projects/${projectId}/videos/${videoId}?auth=${token}`
};

// Expert API
export const expertApi = {
  getAllProjects: (partner = null) => axios.get(`${API}/expert/projects${partner ? `?partner=${encodeURIComponent(partner)}` : ''}`),
  getProject: (id) => axios.get(`${API}/expert/projects/${id}`),
  calculate: (id, data) => axios.post(`${API}/expert/projects/${id}/calculate`, data),
  getPdfUrl: (id, token) => `${API}/expert/projects/${id}/pdf?auth=${token}`
};

// Client API
export const clientApi = {
  getPdfUrl: (id, token) => `${API}/client/projects/${id}/pdf?auth=${token}`
};

// Payments API
export const paymentsApi = {
  createCheckout: (packageId) => {
    const originUrl = window.location.origin;
    return axios.post(`${API}/payments/checkout`, { package_id: packageId, origin_url: originUrl });
  },
  getStatus: (sessionId) => axios.get(`${API}/payments/status/${sessionId}`)
};

// Address API
export const addressApi = {
  autocomplete: (input) => axios.post(`${API}/addresses/autocomplete`, { input }),
  getDetails: (placeId) => axios.post(`${API}/addresses/details?place_id=${placeId}`)
};

export default {
  projects: projectsApi,
  expert: expertApi,
  client: clientApi,
  payments: paymentsApi,
  address: addressApi
};
